module.exports = __webpack_public_path__ + "img/1497447750.65484429.jpg";